import { gql } from '@apollo/client';

export const CREATE_PACKAGE = gql`
  mutation CreatePackage($input: PackageInput!) {
    createPackage(input: $input) {
      _id
      packageType
      name
      amount
      products {
        _id
        productName
        amount
      }
    }
  }
`;

export const EDIT_PACKAGE = gql`
  mutation EditPackageDetails($input: EditPackageInput!) {
    editPackageDetails(input: $input) {
      _id
      packageType
      name
      amount
      products {
        _id
        productName
        amount
      }
    }
  }
`;

export const DELETE_PACKAGE = gql`
  mutation DeletePackage($packageId: String!) {
    deletePackage(packageId: $packageId) {
      acknowledged
      deletedCount
    }
  }
`;

export const ADD_PRODUCT_TO_PACKAGE = gql`
  mutation AddProductToPackage($packageId: String!, $productId: String!) {
    addProductToPackage(packageId: $packageId, productId: $productId) {
      _id
      packageType
      name
      amount
      products {
        _id
        productName
        amount
      }
    }
  }
`;
